export type ConditionOperator =
	| 'equals'
	| 'not_equals'
	| 'has_value'
	| 'is_empty'
	| 'is_checked'
	| 'is_not_checked'
	| 'greater_than'
	| 'less_than'

export interface Condition {
	sourceComponentId: string
	operator: ConditionOperator
	values?: string[]
}

export type CompoundOperator = 'and' | 'or'

export interface ConditionalConfig {
	compoundOperator: CompoundOperator
	conditions: Condition[]
}

export const CONDITION_SOURCE_COMPONENT_NAMES = [
	'select',
	'radio-group',
	'checkbox',
	'text',
	'textarea',
	'rating',
	'number',
] as const

export type ConditionSourceComponentName = (typeof CONDITION_SOURCE_COMPONENT_NAMES)[number]

export const SOURCE_OPERATOR_MAP: Record<ConditionSourceComponentName, ConditionOperator[]> = {
	select: ['equals', 'not_equals', 'has_value', 'is_empty'],
	'radio-group': ['equals', 'not_equals', 'has_value', 'is_empty'],
	checkbox: ['is_checked', 'is_not_checked'],
	text: ['has_value', 'is_empty'],
	textarea: ['has_value', 'is_empty'],
	rating: ['equals', 'not_equals', 'has_value', 'is_empty'],
	number: ['equals', 'not_equals', 'greater_than', 'less_than', 'has_value', 'is_empty'],
}

export const OPERATOR_LABELS: Record<ConditionOperator, string> = {
	equals: 'Equals',
	not_equals: 'Does not equal',
	has_value: 'Has a value',
	is_empty: 'Is empty',
	is_checked: 'Is checked',
	is_not_checked: 'Is not checked',
	greater_than: 'Greater than',
	less_than: 'Less than',
}

export function operatorRequiresValues(operator: ConditionOperator): boolean {
	return ['equals', 'not_equals', 'greater_than', 'less_than'].includes(operator)
}

export function isConditionSource(name: string): name is ConditionSourceComponentName {
	return (CONDITION_SOURCE_COMPONENT_NAMES as readonly string[]).includes(name)
}
